var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-btn",
    _vm._g(
      _vm._b(
        {
          staticClass: "gg-button text-capitalize",
          class: {
            "gg-button--disabled": _vm.$attrs.disabled
          },
          attrs: {
            elevation: "0"
          }
        },
        "v-btn",
        _vm.mergedAttrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm._l(_vm.$slots, function(_, name) {
        return _vm._t(name, null, {
          slot: name
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }